// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// * Coded by Creative Tim
//
// =========================================================
//
// * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "@/store";
// import "./plugins/base";
import "./plugins/chartist";
import "./plugins/vee-validate";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import moment from "moment";
import helpers from "@/plugins/helpers";
import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

Vue.use(helpers, {
  $store: store,
  $router: router,
  $i18n: i18n,
  $swal: Vue.swal,
  $moment: moment,
});

Vue.prototype.$moment = moment;

Vue.config.productionTip = false;

import vClickOutside from "v-click-outside";

Vue.use(vClickOutside);

// Import the functions you need from the SDKs you need
import firebase from "firebase/compat/app";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBiwi4QYaOeHMFXQjKfas7zAkS4EVE3dPg",
  authDomain: "auth.anybook.app",
  projectId: "anybook-321907",
  storageBucket: "anybook-321907.appspot.com",
  messagingSenderId: "690886975969",
  appId: "1:690886975969:web:bd8dc92c7a7664851032a0",
  measurementId: "G-2M5XJDGJ25",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
console.log(app);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
